import Restful from '../utils/restful.js'
// import http from '../utils/http.js'
const project = 'sci/'
const questionnaire = new Restful(project, 'questionnaire')
const question = new Restful(project, 'question')
export default question
export { questionnaire, question }
